import { render } from "./pharmacie_create.vue?vue&type=template&id=c35f8d82"
import script from "./pharmacie_create.vue?vue&type=script&lang=js"
export * from "./pharmacie_create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__